import React, { useState, useRef, useEffect } from 'react';
import { Search, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import './NavbarSearch.css'


const NavbarSearch = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const searchRef = useRef(null);
  
  const products = [
    {
      name: "White Paper Bags",
      image: '/assets/products-with-logo/paper-bags/white-paper-bags.jpg',
      path: '/white-paper-bags'
    },
    {
      name: "Brown Paper Bags",
      image: '/assets/products-with-logo/paper-bags/brown-paper-bag-with-rope-tied-it.jpg',
      path: '/brown-paper-bags'
    },
    {
      name: "Self-Opening Square Paper Bags",
      image:'/assets/products-with-logo/paper-bags/sos-bags.jpg',
      path: '/sos'
    },
    {
      name: "Take Away Bags",
      image: '/assets/products-with-logo/paper-bags/take-away-bags-small.jpg',
      path: '/take-away-bags'
    },
    {
      name: "Promotional Bags",
      image: '/assets/products-with-logo/paper-bags/promotional-bags.jpg',
      path: '/promotional-bags'
    },
    // {
    //   name: "Wrappers",
    //   image: '/assets/products-with-logo/paper-bags/wrappers.jpg',
    //   path: '/wrappers'
    // },
    {
      name: "POD Courier Bags",
      image: '/assets/products-with-logo/courier-bags/pod-courier-bags.jpg',
      path: '/pod-courier-bags'
    },
    {
      name: "Non-POD Courier Bags",
      image: '/assets/products-with-logo/courier-bags/non-pod-courier-bags.jpg',
      path: '/non-pod-courier-bags'
    },
    {
      name: "Ld Shrink",
      image: '/assets/products-with-logo/packaging-products/ld-shrink-film.jpg',
      path: '/ld-shrink-film'
    },
    {
      name: "Liners",
      image: '/assets/products-with-logo/packaging-products/liners.jpg',
      path: '/liners'
    },
    {
      name: "Packaging Films",
      image: '/assets/products-with-logo/packaging-products/packaging-films.jpg',
      path: '/packaging-films'
    }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.trim() === '') {
      setSearchResults([]);
      return;
    }

    const filtered = products.filter(product =>
      product.name.toLowerCase().includes(value.toLowerCase())
    );
    setSearchResults(filtered);
  };

  const handleSearchClick = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setTimeout(() => {
        const input = searchRef.current?.querySelector('input');
        if (input) input.focus();
      }, 100);
    }
  };

  const closeSearch = () => {
    setIsOpen(false);
    setSearchTerm('');
    setSearchResults([]);
  };

  return (
    <div className="position-relative" ref={searchRef}>
      <button 
        className="btn btn-link text-secondary p-0" 
        onClick={handleSearchClick}
      >
        <Search size={20} />
      </button>

      {isOpen && (
        <div className="position-absolute end-0 mt-2 dropdown-menu show" style={{ width: '350px' }}>
          <div className="p-3 border-bottom">
            <div className="input-group">
              <span className="input-group-text bg-white border-end-0">
                <Search size={18} />
              </span>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder="Search products..."
                value={searchTerm}
                onChange={handleSearch}
                style={{ boxShadow: 'none' }}
              />
              {searchTerm && (
                <button
                  className="btn btn-outline-secondary border-start-0"
                  type="button"
                  onClick={() => setSearchTerm('')}
                >
                  <X size={18} />
                </button>
              )}
            </div>
          </div>

          <div className="dropdown-menu-inner" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {searchResults.length > 0 && (
              <div className="py-2">
                {searchResults.map((product, index) => (
                  <Link
                    key={index}
                    to={product.path}
                    className="dropdown-item d-flex align-items-center gap-3 py-2 px-3"
                    onClick={closeSearch}
                  >
                    <div className="flex-shrink-0">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="rounded"
                        style={{ width: '48px', height: '48px', objectFit: 'cover' }}
                      />
                    </div>
                    <div className="flex-grow-1">
                      <p className="mb-0 text-dark">{product.name}</p>
                    </div>
                  </Link>
                ))}
              </div>
            )}

            {searchTerm && searchResults.length === 0 && (
              <div className="p-4 text-center text-secondary">
                No products found matching "{searchTerm}"
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NavbarSearch;